// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__0_NT6","truncatedText":"styles_truncatedText__te71Z","fullText":"styles_fullText___S2Ga","textContainer":"styles_textContainer__Y5Pef"};